import { render, staticRenderFns } from "./CustomerLocation.vue?vue&type=template&id=5ed1dcdd&scoped=true"
import script from "./CustomerLocation.vue?vue&type=script&lang=js"
export * from "./CustomerLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1dcdd",
  null
  
)

export default component.exports